import { FC } from 'react';

import {
    BottomSheet,
    HSpacingContainer,
    Modal,
    NavBar,
    Text,
    TextList,
    VSpacing,
    VSpacingContainer,
} from '@hh.ru/magritte-ui';
import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import useTrls from 'hooks/translation/useTrls';

import { MagritteModalHeader } from 'components/common/MagritteModalHeader/MagritteModalHeader';

interface AutoStrategyDetailsModalProps {
    isVisible: boolean;
    onClose: () => void;
    applicationsGrowthPercent?: string | number;
    applicationsCostReductionPercent?: string | number;
}

const TrlKeys = {
    title: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.title',
    description: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.description',
    advantagesTitle: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.advantagesTitle',
    advantagesItem1: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.advantagesItem1',
    advantagesItem2: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.advantagesItem2',
    advantagesItem3: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.advantagesItem3',
    resultText: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.resultText',
    howToStartTitle: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.howToStartTitle',
    howToStartItem1: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.howToStartItem1',
    howToStartItem2: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.howToStartItem2',
    howToStartItem3: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.howToStartItem3',
    finalText: 'AuctionBuilder.BiddingStrategySelect.AutoStrategyDetailsModal.finalText',
};

export const AutoStrategyDetailsModal: FC<AutoStrategyDetailsModalProps> = ({
    isVisible,
    onClose,
    applicationsGrowthPercent,
    applicationsCostReductionPercent,
}) => {
    const trls = useTrls();

    const content = (
        <VSpacingContainer default={16}>
            <Text typography="label-1-regular">{trls(TrlKeys.description)}</Text>

            <Text typography="title-4-semibold">{trls(TrlKeys.advantagesTitle)}</Text>
            <TextList Element="ul">
                <Text typography="label-1-regular">{trls(TrlKeys.advantagesItem1)}</Text>
                <Text typography="label-1-regular">{trls(TrlKeys.advantagesItem2)}</Text>
                <Text typography="label-1-regular">{trls(TrlKeys.advantagesItem3)}</Text>
            </TextList>

            <Text typography="label-1-regular">
                {trls(TrlKeys.resultText, [applicationsGrowthPercent, applicationsCostReductionPercent])}
            </Text>

            <Text typography="title-4-semibold">{trls(TrlKeys.howToStartTitle)}</Text>
            <TextList Element="ol">
                <Text typography="label-1-regular">{trls(TrlKeys.howToStartItem1)}</Text>
                <Text typography="label-1-regular">{trls(TrlKeys.howToStartItem2)}</Text>
                <Text typography="label-1-regular">{trls(TrlKeys.howToStartItem3)}</Text>
            </TextList>

            <Text typography="label-1-regular">{trls(TrlKeys.finalText)}</Text>
        </VSpacingContainer>
    );

    return (
        <>
            <Modal
                size="medium"
                visible={isVisible}
                onClose={onClose}
                header={
                    <MagritteModalHeader
                        title={trls(TrlKeys.title)}
                        actions={<CrossOutlinedSize24 initialColor="secondary" onClick={onClose} />}
                    />
                }
                data-qa="auto-strategy-details-modal"
                position="right"
            >
                {content}
            </Modal>
            <BottomSheet
                height="content"
                visible={isVisible}
                onClose={onClose}
                header={
                    <HSpacingContainer default={12}>
                        <NavBar>
                            <NavBar.Pane>
                                <Text typography="title-4-semibold">{trls(TrlKeys.title)}</Text>
                            </NavBar.Pane>
                        </NavBar>
                    </HSpacingContainer>
                }
                data-qa="auto-strategy-details-bottom-sheet"
            >
                {content}
                <VSpacing default={12} />
            </BottomSheet>
        </>
    );
};
